module.exports = __webpack_public_path__ + "img/copy.6fc2809d.svg";